import $ from 'jquery'

/** A selector to retrieve all relevant form controls */
const elementTypes = new Set(['select', 'input', 'textarea', 'button'])
let selector = Array.from(elementTypes).join(', ')

/**
 * Disables the interactive controls found in the given element
 * @param {Element|jQuery} el the element
 */
function disableControls(el, options={}) {
	el = $(el)
	let controls = el.find(selector)
	const elementType = el[0]?.nodeName?.toLowerCase()
	if (elementTypes.has(elementType)) {
		controls = el
	}
	if (options.filter) {
		controls = controls.filter(options.filter)
	}
	controls.attr('disabled', true)
	controls.addClass('is-disabled')
}

export default disableControls
export { selector }

disableControls.__filename__ = 'components/disable-controls.js'
